export default "__VITE_ASSET__DVsq2LOy__"